import { ROUTE_SIGNIN, ROUTE_SIGNUP } from "../globals/constants";

export const LAYOUT_CONFIG = {
  SIGN_IN_BUTTON: {
    hidden_on_routes: [ROUTE_SIGNIN],
  },
  SIGN_UP_BUTTON: {
    hidden_on_routes: [ROUTE_SIGNUP],
  },
};
